import ResourceCard from '@stories/Components/Cards/ResourceCard/ResourceCard';
import React from 'react';
import S from './RelatedResources.styles';
const RelatedResources = ({ items, title, contentStyle, titleStyle }) => {
    return (React.createElement(S.Container, null,
        React.createElement(S.Title, { itemCount: items.length, contentStyle: titleStyle }, title),
        React.createElement(S.ItemList, { itemCount: items.length, contentStyle: contentStyle }, items.map((item) => (React.createElement(S.Item, { key: item.id },
            React.createElement(ResourceCard, { ...item })))))));
};
export default RelatedResources;
